module.exports = __webpack_public_path__ + "static/img/end.4c1af31d.jpg";